import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addDirectBillingListData,
  deleteDirectBillingListData,
  fetchDirectBillingList,
  updateDirectBillingListData,
} from "../../apis/directBilling";

export const fetchDirectBillingDatas = createAsyncThunk(
  "directBilling/fetchDirectBilling",
  async (_, { rejectWithValue }) => {
    try {
      const fees = await fetchDirectBillingList();
      return fees;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.directBilling.isDataFetched; // Adjust path based on your state structure
    },
  }
);

export const updateDirectBilling = createAsyncThunk(
  "directBilling/updateDirectBilling",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateDirectBillingListData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteDirectBilling = createAsyncThunk(
  "directBilling/deleteDirectBilling",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteDirectBillingListData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewDirectBillingData = createAsyncThunk(
  "directBilling/addDirectBilling",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addDirectBillingListData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
